var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTimetypeSwitchFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h200v200H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.123 62.058h37.279V45.386c0-4.168 1.398-7.873 6.523-3.242l38.677 34.27a3.46 3.46 0 0 1 0 5.558l-38.677 34.27c-5.591 5.094-6.523.463-6.523-3.705v-5.746c0-5.523-4.477-10-10-10H89.123c-3.728 0-6.99-3.242-6.99-6.947v-20.84c0-4.167 3.262-6.946 6.99-6.946z",
    fill: "#00ADF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.877 103.423H85.064c-5.523 0-10-4.477-10-10v-6.209c0-4.63-1.864-8.336-6.99-3.704l-38.676 34.27c-1.864 1.389-1.864 4.168 0 6.02l38.677 34.27c5.591 4.631 6.99 0 6.99-4.168v-15.746h36.812c4.194 0 7.456-3.241 7.456-6.946v-20.84c0-4.168-3.262-6.947-7.456-6.947z",
    fill: "#3FAE29"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimetypeSwitchFull);
export default __webpack_public_path__ + "static/media/icon-timetype-switch-full.cbc2304f8f8172d1d0fa6d8a69c02ead.svg";
export { ForwardRef as ReactComponent };